import type {
  CoachTemplateName,
  CoachTemplateView,
  PublishedCoachTemplate,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-1355 — the coach templates ("Coachmallar"). The admin edits and
// publishes; the coach's welcome draft reads the published text.

const BASE = `${API_BASE}/employee-api/v1/coach-templates`;

function url(name: CoachTemplateName, rest = ""): string {
  return `${BASE}/${encodeURIComponent(name)}${rest}`;
}

async function send<T>(
  method: "PUT" | "POST" | "DELETE",
  target: string,
  body?: unknown,
): Promise<T> {
  const res = await apiFetch(target, {
    method,
    headers: { "Content-Type": "application/json", ...tenantHeader() },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchPublishedCoachTemplate(
  name: CoachTemplateName,
): Promise<PublishedCoachTemplate> {
  const res = await apiFetch(url(name, "/published"), {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchCoachTemplate(
  name: CoachTemplateName,
): Promise<CoachTemplateView> {
  const res = await apiFetch(url(name), {
    headers: tenantHeader(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export function saveCoachTemplateDraft(
  name: CoachTemplateName,
  body: string,
): Promise<CoachTemplateView> {
  return send("PUT", url(name, "/draft"), { body });
}

export function discardCoachTemplateDraft(
  name: CoachTemplateName,
): Promise<CoachTemplateView> {
  return send("DELETE", url(name, "/draft"));
}

export function publishCoachTemplate(
  name: CoachTemplateName,
): Promise<CoachTemplateView> {
  return send("POST", url(name, "/publish"));
}

export function rollbackCoachTemplate(
  name: CoachTemplateName,
  toVersion: number,
): Promise<CoachTemplateView> {
  return send("POST", url(name, "/rollback"), { toVersion });
}
